/* eslint-disable camelcase */

import drivers from './taxi/drivers'
import cars from './taxi/cars'
import contracts from './taxi/contracts'
import scans from './taxi/scans'
import mapCars from './taxi/mapCars'
import companies from './taxi/companies'
import templates from './taxi/templates'
import user from './taxi/user'
import ioParameters from './taxi/ioParameters'
import trips from './taxi/trips'
import waybill from './taxi/waybill'
import trackDevice from './taxi/trackDevice'

const state = {
  title: '',
  modulesLoaded: []
}

const getters = {
}

const mutations = {
  setHeaderTitle (state, title) {
    state.title = title
    document.title = 'Stattika › ' + title.items.map(item => item.title).join(' › ')
  }
}

const actions = {
  setTitle ({ commit }, title) {
    commit('setHeaderTitle', title)
  }
}

export default {
  namespaced: true,
  modules: {
    drivers,
    cars,
    contracts,
    scans,
    user,
    mapCars,
    companies,
    templates,
    ioParameters,
    trips,
    waybill,
    trackDevice
  },
  state,
  actions,
  mutations,
  getters
}
